import styled from "styled-components";

const BoxBeltsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;

    & .box-belts-list {
        display: flex;
        flex-direction: column;
    }
`;

const RowInfoSingleBelt = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 5px 0;

    & img {
        width: 25px;
        height: 25px;
        object-fit: contain;
    }
`;

function WrestlerBelts({ wrestlerData }: any) {
    return (
        <BoxBeltsContainer>
            {/* Ciclo le belts */}
            {wrestlerData.belts.map((belt: any, key: any) => (
                <RowInfoSingleBelt key={key}>
                    <img src={process.env.REACT_APP_STORAGE_URL + belt.img_path} alt={belt.img_path + "_alt"} />
                    <span className="px-1">{belt.belt_count}x {belt.name}</span>
                </RowInfoSingleBelt>
            ))}
        </BoxBeltsContainer>
    );
}

export default WrestlerBelts;
